import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { some as _some } from 'lodash';

import { fromBillAccountCanRegisterActions } from '@amfam/billing/bill-account-can-register/data-access';
import { BillAccountActions } from '@amfam/billing/billaccount/data-access';
import {
  BillingRegistrationSelectors,
  PendingRegistration
} from '@amfam/billing/registration/data-access';

import { BillAccountRegisterWrapperComponent } from '../bill-account-register-wrapper/bill-account-register-wrapper.component';

@Injectable()
export class BillAccountRegistrationGuard {
  private pendingRegistrations: PendingRegistration[];

  constructor(private store: Store) {
    this.store
      .select(BillingRegistrationSelectors.selectPendingRegistrations)
      .subscribe(pending => {
        this.pendingRegistrations = pending;
      });
  }

  /*
    canDeactivate method takes Component, ActivatedRouteSnapshot,RouterStateSnapshot, nextState: RouterStateSnapshot as parameters.
    nextState gives us future url.
  */
  canDeactivate(
    _component: BillAccountRegisterWrapperComponent,
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): any {
    // If the list contains an unassociated bill account, reload the bill accounts list
    if (
      nextState.url !== '/terms/billing' &&
      _some(this.pendingRegistrations, { associated: false })
    ) {
      this.store.dispatch(BillAccountActions.billAccountsLoad());
      this.store.dispatch(fromBillAccountCanRegisterActions.CanRegisterClearAction());
    }

    return true;
  }
}
